import React from "react";
import { useSelector } from "react-redux";


const Footer = () => {
  const appConfigState = useSelector((state) => state.AppConfigReducer);
  const { expandMenuBar } = appConfigState;
  return (
    <>
    <div className={`hidden sm:block fixed bottom-0 mt-2 p-2`}>
      <footer class="text-black text-sm p-2">
        &copy; 2025 Datacloudtech .
      </footer>
      </div>
      <div className={`w-screen fixed bottom-0 block sm:hidden p-1 text-center bg-white`}>
      <footer class="text-black text-sm p-2">
        &copy; 2025 Datacloudtech .
      </footer>
      </div>
      </>
  );
};
export default Footer;

// import React from "react";
// import { useSelector } from "react-redux";

// const Footer = () => {
//   const appConfigState = useSelector((state) => state.AppConfigReducer);
//   const { expandMenuBar } = appConfigState;
//   const appConfigHoverState = useSelector((state) => state.AppConfigHoverReducer);
//   const { hover } = appConfigHoverState;
//   const marginLeft = expandMenuBar || hover ? "ml-60 p-4" : "ml-28 p-4"; 

//   return (
//     // <div className={`fixed bottom-0 left-0 max-w-full text-black ml- text-sm ${marginLeft}`}>
//     <div
//       className={`fixed bottom-0 left-0 w-full text-black text-sm bg-white shadow-md p-2 md:p-4
//       ${expandMenuBar || hover ? "md:ml-60" : "md:ml-28"} transition-all duration-300`}
//     >
//       <footer className="text-center md:text-left">
//         &copy; 2025 Unisoft Solutions.
//       </footer>
//     </div>
//   );
// };

// export default Footer;
